<template>
  <v-container>
    <div v-if="alerta">
      <alert-empty></alert-empty>
    </div>
    <v-layout>
      <v-flex>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text"
            >Calendario de visitas - busqueda</v-toolbar-title
          >
        </v-toolbar>
      </v-flex>
    </v-layout>
    <br />
    <br />
    <v-layout justify-content: center>
      <v-flex>
        <v-select
          v-model="fechaInicioValue"
          :items="fechaInicioSelect"
          label="Fecha desde"
        ></v-select>
      </v-flex>
      <v-flex>
        <v-select
          v-model="fechaFinValue"
          :items="fechaFinSelect"
          label="Fecha hasta"
        ></v-select>
      </v-flex>
      <v-btn
        fab
        dark
        color="teal"
        title="Fitrar visitas"
        @click="filterVisit()"
      >
        <v-icon dark>filter_list</v-icon>
      </v-btn>
      <v-btn
        fab
        dark
        color="red darken-4"
        title="Limpiar filtros"
        @click="clear()"
      >
        <v-icon dark>clear_all</v-icon>
      </v-btn>
    </v-layout>
    <v-layout>
      <v-flex>
        <grid-visita
          :key="visitaGrid"
          :visitas="visitasCont"
          :contratoId="contratoId"
        ></grid-visita>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from "vue";
import GridVisita from "./GridVisitas.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import axios from "axios";

export default {
  name: "visita-sub-tab",

  components: {
    GridVisita,
    AlertEmpty,
  },
  props: {
    proveedor: {},
    show: Boolean,
    tipeView: "",
  },
  data() {
    return {
      contratoId: "",
      allowSpaces: false,
      valid: false,
      fechaInicioValue: null,
      fechaFinValue: null,
      fechaInicioSelect: [],
      fechaFinSelect: [],
      visitasCont: [],
      filter: false,
      visitaGrid: 0,
      alerta: false,
    };
  },

  computed: {},

  created() {
    this.contratoId = this.$store.getters.contratoStored;
    if (
      this.contratoId == null ||
      this.contratoId == "" ||
      this.contratoId == undefined
    ) {
      this.contratoId = this.$route.params.contratoId;
      this.loadDataVisitas();
    } else {
      this.loadDataVisitas();
    }
  },
  methods: {
    async loadVisitasFilter() {
      let that = this;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        idContrato: idContrato,

        from:
          this.fechaInicioValue && this.fechaInicioValue != null
            ? this.fechaInicioValue
            : null,
        to:
          this.fechaFinValue && this.fechaFinValue != null
            ? this.fechaFinValue
            : null,
      };
      return await axios
        .post("/visita/search_date", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    submit() {
      this.$v.$touch();
    },
    clear() {
      this.fechaInicioValue = "";
      this.fechaFinValue = "";
      this.loadDataVisitas();
    },
    async filterVisit() {
      this.filter = true;
      this.visitas = await this.loadVisitasFilter();
      this.visitasCont = this.visitas;
    },

    loadData() {},
    async loadDataVisitas() {
      //CARGA DE USUARIOS SEPARADOS POR TIPO
      this.visitas = await this.loadVisitsAll();
      this.visitasCont = this.visitas;
      if (this.visitas.length > 0) {
        this.loadFechaSelect();
        this.alerta = false;
      } else {
        this.alerta = true;
      }
    },
    async loadVisitsAll() {
      let that = this;
      return await axios
        .get("/visitas/" + that.contratoId)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    loadFechaSelect() {
      let visi = [];
      this.visitas.forEach(function (v) {
        let index = visi.findIndex((x) => x.fechaVisita == v.fechaVisita);
        if (index === -1) {
          if (v.fechaVisita != null && v.fechaVisita != "") {
            visi.push(v.fechaVisita);
          }
        }
      });
      console.log(visi);
      this.fechaInicioSelect = visi;
      this.fechaFinSelect = visi;
    },
    reloadVisitas() {
      this.visitaGrid += 1;
    },
  },
};
</script>
